<template>
  <div
    class="cursor-pointer px-3 py-1 hover:bg-gray-100"
    :data-test="data_test"
    :role="role"
    :class="{ 'cursor-not-allowed! opacity-50': disabled }"
    v-bind="$attrs"
    v-tooltip.left="{ value: tooltip }"
    @click="onClick"
  >
    <slot />
  </div>
</template>

<script setup>
import { inject } from 'vue';

const emit = defineEmits(['click']);

const props = defineProps({
  data_test: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  role: { type: String, default: 'menuitem' },
  keep_open: { type: Boolean, default: false },
  tooltip: { type: String, default: null },
});

const dropdownHide = inject('dropdownHide', null);

const onClick = () => {
  if (props.disabled) return;
  emit('click');
  if (!props.keep_open && dropdownHide) {
    dropdownHide();
  }
};
</script>
